var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showScore && _vm.score)?_c('b-rate',{attrs:{"value":_vm.rate,"disabled":_vm.disabled,"custom-text":_vm.score / 2 + ' / 5',"show-text":false,"show-score":false}}):_c('b-rate',{attrs:{"value":_vm.rate,"disabled":_vm.disabled,"show-text":false,"show-score":false}})
}
var staticRenderFns = []

export { render, staticRenderFns }